module.exports = __webpack_public_path__ + "img/moscone.6c75f5c7.svg";